module.exports = "<div id=\"gdpr-cookie-banner-outerwrap\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-page-components/src/gdprCookieBanner/template.html
// module id = ../node_modules/xo-page-components/src/gdprCookieBanner/template.html
// module chunks = 0